if (!customElements.get("swymcs-custom-wishlist-popup")) {
    class SwymcsCustomWishlistPopup extends HTMLElement {
        static TYPES = {
            WISHLIST: 'wishlist',
            SFL: 'sfl'
        };

        static TABS = {
            WISHLIST: 'swymcs-popup-tab-button-wishlist',
            SFL: 'swymcs-popup-tab-button-sfl'
        };

        static CONFIG = {
            MIN_LIST_NAME_LENGTH: 3,
            MAX_LIST_NAME_LENGTH: 50,
            BUTTON_TEXT: {
                ADD_TO_CART: 'Add to Cart',
                ADDED_TO_CART: 'Added to cart',
                ADDING: 'Adding...',
                SOLD_OUT: 'Sold Out'
            },
            ERROR_MESSAGES: {
                LIST_NAME_REQUIRED: 'Please enter a list name',
                LIST_NAME_TOO_SHORT: 'List name must be at least 3 characters',
                LIST_NAME_TOO_LONG: 'List name must be less than 50 characters',
                EMAIL_REQUIRED: 'Please enter recipient email address',
                SHARE_FAILED: 'Failed to share list. Please try again.',
                CART_ADD_FAILED: 'Failed to add product to cart. Please try again.',
                SWYM_NOT_INITIALIZED: 'Swym not initialized',
                LIST_ID_REQUIRED: 'No list ID provided'
            }
        };

        // Add state management with initial values
        state = {
            currentTab: 'wishlist',
            currentListId: null,
            lists: [],
            sflItems: [],
            isLoading: {
                wishlist: false,
                sfl: false
            }
        };

        // Cache for product data to avoid redundant API calls
        #productCache = new Map();

        constructor() {
            super();
            this._initializeSwymComponent();
        }

        _initializeSwymComponent() {
            if (!window.SwymCallbacks) window.SwymCallbacks = [];
            window.SwymCallbacks.push(this._initSwym.bind(this));
        }

        async _initSwym(swat) {
            // console.log(swat, "custom wishlist popup initialized");
            this.swat = swat;
            swat.ui.open = () => {
                if(!window.isCustomer){
                    (function swymRedirectToLogin(customURL){
                        var accountsPageURL = customURL || window.origin + "/account/login";
                        window.location = accountsPageURL;
                      })();
                }else{
                    this.openPopup();
                    document.querySelector('html').classList.add('swym-modal-active');
                }
            }

            await this._initializeSaveForLater(3, 200);
            this.Strings = swat.retailerSettings.Strings;
            this.setupElements();
            this.handleBackgroundClick();
            // this.initShareAndAdditionalOptionsPopup();
            this.initConfirmationModalCloseButton();
            
            // Instead of opening automatically, just pre-fetch the data
            // this.fetchInitialData();
            // console.log('Init Swym End')
        }

        // New method to fetch data without opening the popup
        // async fetchInitialData() {
        //     try {
        //         // Fetch lists but don't display them yet
        //         const wishlists = await this.fetchWishlist();
        //         this.lists = wishlists;
                
        //         // Pre-fetch SFL items
        //         await this.fetchSfl(false); // Pass false to indicate we're not showing UI
        //     } catch (error) {
        //         console.error('Error pre-fetching initial data:', error);
        //     }
        // }

        async _initializeSaveForLater(retryCount, delay) {
            if (!this.swat) {
                const error = 'Swym not initialized';
                console.error(error);
                return Promise.reject(error);
            }
            if (!this.swat.SaveForLater || typeof this.swat.SaveForLater.init !== 'function') {
                if (retryCount > 0) {
                    console.log(`SaveForLater not available, retrying... (${retryCount} attempts left)`);
                    await new Promise(resolve => setTimeout(resolve, delay));
                    return this._initializeSaveForLater(retryCount - 1, delay);
                }
                const error = 'Swym SaveForLater module not available after retries';
                console.error(error);
                return Promise.reject(error);
            }
            return new Promise((resolve, reject) => {
                this.swat.SaveForLater.init(
                    (response) => {
                        // console.log("Successfully Initialized Save for Later List", response);
                        this.sflListId = response.list.lid;
                        resolve(response);
                    },
                    (error) => {
                        console.error("Error while creating Save For Later List", error);
                        reject(error);
                    }
                );
            });
        }

        setupElements() {
            // Store all relevant DOM elements in a single object for better organization
            this.elements = {
                popupContainer: this.querySelector("#swymcs-popup-container"),
                emptyWishlistContainer: this.querySelector("#swymcs-popup-empty-wishlist-container"),
                emptySflContainer: this.querySelector("#swymcs-popup-empty-sfl-container"),
                sflGrid: this.querySelector("#swymcs-sfl-items-grid"),
                wishlistGrid: this.querySelector("#swymcs-wishlist-items-grid"),
                wishlistsTitle: this.querySelector(".swymcs-popup-wishlists-title"),
                listsContainer: this.querySelector("#swymcs-popup-wishlists-container"),
                popupBg: this.querySelector('#swymcs-popup-bg'),
                closeBtn: this.querySelector("#swymcs-close-btn"),
                tabButtonWishlist: this.querySelector("#swymcs-popup-tab-button-wishlist"),
                tabButtonSfl: this.querySelector("#swymcs-popup-tab-button-sfl"),
                tabContentWishlist: this.querySelector("#swymcs-popup-tab-content-wishlist"),
                tabContentSfl: this.querySelector("#swymcs-popup-tab-content-sfl"),
                continueShoppingBtn: this.querySelector("#swymcs-popup-continue-shopping-btn"),
                openCartBtn: this.querySelector("#swymcs-popup-open-cart-btn"),
                wishlistsItemsContainer: this.querySelector("#swymcs-popup-wishlists-items-container"),
                backToWishlistsBtn: this.querySelector("#swymcs-list-back-btn"),
                mobileBackToWishlistsBtn: this.querySelector("#swymcs-list-back-button-mobile"),
                listSwitchDiv: this.querySelector("#swymcs-list-switcher"),
                sflHeader: this.querySelector("#swymcs-sfl-title-and-button-inner"),
                wishlistLoadingIndicator: this.querySelector("#swymcs-wishlist-loading-indicator"),
                sflLoadingIndicator: this.querySelector("#swymcs-sfl-loading-indicator"),
                additionalOptionsBackground: this.querySelector("#swymcs-additonal-options-background"),
                additionalOptionsButton: this.querySelector('#swymcs-list-actions-btn'),
                additionalOptionsContainer: this.querySelector('#swymcs-additional-options'),
                confirmationModal: this.querySelector("#swymcs-confirmation-modal"),
                confirmationText: this.querySelector("#swymcs-confirmation-text"),
                confirmYes: this.querySelector("#swymcs-confirm-yes"),
                confirmNo: this.querySelector("#swymcs-confirm-no"),
                clearListButton: this.querySelector("#swymcs-clear-list"),
                deleteListButton: this.querySelector("#swymcs-delete-list"),
                sflMoveAllToCartButton: this.querySelector("#swymcs-sfl-move-all-to-cart-btn"),
                sharePopup: this.querySelector('#swymcs-share-popup'),
                sharePopupBg: this.querySelector('.swymcs-share-popup-overlay'),
                shareForm: this.querySelector('#swymcs-share-form'),
                formGroups : this.querySelectorAll('#swymcs-share-form .swymcs-form-group'),
                shareCloseBtn: this.querySelector('.swymcs-share-popup-close'),
                shareListSubmitBtn: this.querySelector('#swymcs-share-list-submit'),
                copyLinkBtn: this.querySelector('#swymcs-copy-link-btn'),
                facebookShareBtn: this.querySelector('#swymcs-facebook-share-btn'),
                twitterShareBtn: this.querySelector('#swymcs-twitter-share-btn'),
                shareListBtn: this.querySelector('#swymcs-list-share-btn'),
                shareAlternateOptionsLabel : this.querySelector('.swymcs-other-share-options p'),
                copyLinkText : this.querySelector('#swymcs-copy-link-btn span'),
                shareListData: null,
                currentActionType: null,
                listSwitcherContainer: this.querySelector('#swymcs-list-switcher-container'),
                closeConfirmationModalBtn: this.querySelector('#swymcs-confirmation-close-btn'),
                customProductNotifCloseBtn: this.querySelector('#swymcs-custom-notif-close-button'),
                emptyListTitle : this.querySelectorAll('.swymcs-popup-empty-wishlist-title'),
                emptyListDescription : this.querySelector('.swymcs-popup-empty-wishlist-description'),
                emptySFLListTitle : this.querySelector('.swymcs-popup-empty-sfl-title'),
                emptySFLListDescription : this.querySelector('.swymcs-popup-empty-sfl-description'),
                backBtnCTA : this.querySelector("#swymcs-list-back-btn span"),
                clearListText : this.querySelector('#swymcs-clear-list span'),
                deleteListText : this.querySelector('#swymcs-delete-list span'),
                createNewListOptionText : this.querySelector('#swymcs-new-list span'),
                shareListPopupHeading : this.querySelector('.swymcs-share-popup-title'),
                renameListButton: this.querySelector('#swymcs-rename-button'),
                renameListName: this.querySelector('#swymcs-renamelist-popup #swym-custom-new-list-name-input'),
                renameListPopup: this.querySelector('#swymcs-renamelist-popup'),
                renameListBg: this.querySelector('#swymcs-renamelist-popup .swymcs-share-popup-overlay'),
                closeRenameListButton: this.querySelector('#swymcs-renamelist-popup #swym-custom-notconfirm-list-button'),
                confirmRenameListButton: this.querySelector('#swymcs-renamelist-popup #swym-custom-confirm-list-button'),
                renameListGuideLabel: this.querySelector('.swymcs-renamelist-popup-content p#swym-list-guide-text'),
                newListGuideLabel: this.querySelector('.swymcs-newlist-popup-content p#swym-list-guide-text'),
                createNewListButton: this.querySelector('#swymcs-new-list'),
                createNewListName: this.querySelector('#swymcs-newlist-popup #swym-custom-new-list-name-input'),
                createNewListPopup: this.querySelector('#swymcs-newlist-popup'),
                createNewListBg: this.querySelector('#swymcs-newlist-popup .swymcs-share-popup-overlay'),
                closeCreateNewListButton: this.querySelector('#swymcs-newlist-popup #swym-custom-notconfirm-list-button'),
                confirmCreateNewListButton: this.querySelector('#swymcs-newlist-popup #swym-custom-confirm-list-button'),
                successIcon : `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="30px" height="30px" fill="#D6CCC2"><path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"/></svg>`,
                errorIcon: `<svg xmlns="http://www.w3.org/2000/svg" width="30px" height="30px" viewBox="0 0 512 512" fill="#D6CCC2"><path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM175 175c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z"/></svg>`,

            };

            this.updateLocaleStrings();
            this.addEventListeners();
            
            // Initialize share popup functionality
            this.initShareAndAdditionalOptionsPopup();
            
            // Add this line to set up the background click handler
            this.handleBackgroundClick();
        }

        updateLocaleStrings() {
            const swat = this.swat;
            this.elements.confirmYes.textContent = this.Strings.Yes;
            this.elements.confirmNo.textContent = this.Strings.No;
            this.elements.shareListPopupHeading.textContent = this.Strings.ShareWishlistPopupHeading;
            this.elements.formGroups[0].querySelector('label').textContent = this.Strings.ShareWishlistSenderName;
            this.elements.formGroups[1].querySelector('label>span').textContent = this.Strings.ShareWishlistRecipientsEmail;
            this.elements.formGroups[2].querySelector('label').textContent = this.Strings.ShareWishlistMessage;
            this.elements.shareListSubmitBtn.textContent = this.Strings.ShareWishlistEmailCTA;
            this.elements.shareAlternateOptionsLabel.textContent = this.Strings.ShareWishlistAlternateShareLabel;
            this.elements.copyLinkText.textContent = this.Strings.ShareWishlistCopyLinkText;

            this.elements.backBtnCTA.textContent = this.Strings.BackToListofListsCTA;
            this.elements.clearListText.textContent = this.Strings.WishlistContextMenuClearList;
            this.elements.deleteListText.textContent = this.Strings.WishlistContextMenuDeleteList;
            
            this.elements.tabButtonSfl.textContent = this.Strings.SFLTabCTA;

            // /* EMPTY LIST CONTAINER */
            (Shopify.locale == 'de') 
            ? this.elements.emptyListTitle[1].textContent = this.Strings.EmptyWishlistsHeading.replace('Liebst du ein Produkt? ', '')
            : this.elements.emptyListTitle[1].textContent = this.Strings.EmptyWishlistsHeading.replace('Love it? ', '');  
            this.elements.emptyListDescription.textContent = this.Strings.EmptyWishlistsText;
            this.elements.emptySFLListTitle.textContent = this.Strings.SFLListEmptyText;
            this.elements.emptySFLListDescription.textContent = this.Strings.SFLSaveItemsText;
            this.elements.continueShoppingBtn.textContent = this.Strings.EmptyWishlistsCTA;
            this.elements.openCartBtn.textContent = this.Strings.SFLOpenCartCTA;

            // Rename and Create List 
            this.elements.createNewListOptionText.textContent = this.Strings.AddWishlistPopupCTAAddNew;
            this.elements.newListGuideLabel.textContent = this.Strings.AddWishlistPopupCTAAddNew;
            if(window.Shopify.locale == 'de'){
                this.elements.renameListGuideLabel.textContent = 'Benennen Sie Ihre Wunschliste um';
                this.elements.confirmRenameListButton.textContent = 'Speichern';
                this.elements.confirmCreateNewListButton.textContent = 'Speichern';
                this.elements.closeRenameListButton.textContent = 'Zurück';
                this.elements.closeCreateNewListButton.textContent = 'Zurück';
            }else if(window.Shopify.locale == 'nl'){
                this.elements.renameListGuideLabel.textContent = 'Hernoem uw Wishlist';
                this.elements.confirmRenameListButton.textContent = 'Opslaan';
                this.elements.confirmCreateNewListButton.textContent = 'Opslaan';
                this.elements.closeRenameListButton.textContent = 'Terug';
                this.elements.closeCreateNewListButton.textContent = 'Terug';
            }else {
                this.elements.renameListGuideLabel.textContent = 'Rename your Wishlist';
                this.elements.confirmRenameListButton.textContent = 'Save';
                this.elements.confirmCreateNewListButton.textContent = 'Save';
                this.elements.closeRenameListButton.textContent = 'Back';
                this.elements.closeCreateNewListButton.textContent = 'Back';
            }
          }

        // Clean up resources when element is removed from DOM
        disconnectedCallback() {
            // Remove all event listeners to prevent memory leaks
            this.elements?.popupBg?.removeEventListener("click", this.closePopup);
            this.elements?.closeBtn?.removeEventListener("click", this.closePopup);
            this.elements?.tabButtonWishlist?.removeEventListener("click", this.handleTabWishlistClick);
            this.elements?.tabButtonSfl?.removeEventListener("click", this.handleTabSflClick);
            this.elements?.continueShoppingBtn?.removeEventListener("click", this.handleContinueShopping);
            this.elements?.openCartBtn?.removeEventListener("click", this.handleOpenCart);
            this.elements?.backToWishlistsBtn?.removeEventListener("click", this.backToWishlists);
            this.elements?.mobileBackToWishlistsBtn?.removeEventListener("click", this.backToWishlists);
            
            // Remove delegated event listeners
            this.elements?.wishlistGrid?.removeEventListener("click", this.handleProductCardClick);
            this.elements?.sflGrid?.removeEventListener("click", this.handleProductCardClick);
            
            // Clear data caches
            this.#productCache.clear();
        }

        // Store bound methods to enable proper removal in disconnectedCallback
        closePopup = () => {
            this.elements.popupContainer?.classList.add("swym-hide-container");
            document.querySelector('html').classList.remove("swym-modal-active");
            // also close the additional options container
            this.elements.additionalOptionsContainer?.classList.add("swym-hide-container");
            this.elements.additionalOptionsBackground?.classList.add("swym-hide-container");
            this.elements.sharePopup?.classList.add("swym-hide-container");
        }

        handleTabWishlistClick = this.debounce(() => {
            this.switchTab(SwymcsCustomWishlistPopup.TABS.WISHLIST);
        }, 0);

        handleTabSflClick = this.debounce(() => {
            this.switchTab(SwymcsCustomWishlistPopup.TABS.SFL);
        }, 0);

        handleContinueShopping = () => {
            window.location.href = window.Shopify.routes.root;
        }

        handleOpenCart = () => {
            window.location.href = '/cart';
        }

        handleProductCardClick = (e) => {
            e.stopPropagation();
            // console.log('handleProductCardClick called', e);
            // if the click event is not related to buttons, return early
            if (!e.target.classList.contains('swymcs-product-card-remove-btn') && 
                !e.target.classList.contains('swymcs-product-card-btn')) {
                return;
            }
            const productCard = e.target.closest('.swymcs-product-card');
            if (!productCard) return;
            
            const productType = productCard.getAttribute('productType');
            const listId = productCard.getAttribute('data-lid');
            const product = {
                empi: productCard.dataset.empi,
                epi: productCard.dataset.epi,
                du: productCard.dataset.du
            };

            const isRemoveAction = e.target.classList.contains('swymcs-product-card-remove-btn');
            const isAddToCartAction = e.target.classList.contains('swymcs-product-card-btn');

            this.processProductAction(productType, listId, product, isRemoveAction, isAddToCartAction, productCard);
        }

        // Extract product action logic to reduce complexity
        async processProductAction(productType, listId, product, isRemoveAction, isAddToCartAction, productCard) {
            try {
                if(isRemoveAction) {
                    await this.performProductAction('removeFromList', product, {
                        productCard,
                        listId,
                        productType
                    }) 
                }else if(isAddToCartAction){
                    await this.performProductAction('addToCart', product, {
                        productCard, listId, productType
                    })
                }
            } catch (error) {
                console.error('Error handling product card action:', error);
                // Error already shown by performProductAction
            }
        }

        // Helper methods for updating UI after item removal
        updateWishlistAfterRemove(listId, epi) {
            const list = this.lists.find(l => l.lid == listId);
            if (list) {
                list.listcontents = list.listcontents.filter(item => item.epi != epi);
                
                // Update UI based on list state
                const isEmpty = list.listcontents.length === 0;
                
                // Batch DOM updates
                requestAnimationFrame(() => {
                    if(isEmpty) {
                        this.elements.emptyWishlistContainer?.classList.remove("swym-hide-container");
                        this.elements.wishlistGrid?.classList.add("swym-hide-container");
                    } else {
                        this.elements.wishlistGrid.innerHTML = this.generateProductGridItems(list, SwymcsCustomWishlistPopup.TYPES.WISHLIST);
                    }
                    
                    // IMPORTANT: Always keep the wishlistsTitle hidden when viewing a specific list
                    this.elements.wishlistsTitle?.classList.add("swym-hide-container");
                });
                
                // Update list dropdown option text
                const option = this.elements.listSwitchDiv.querySelector(`option[value="${listId}"]`);
                if (option) {
                    // console.log('Updating option text with new count:', list.listcontents.length);
                    option.textContent = `${list.lname} (${list.listcontents.length})`;
                }
            }
        }

        updateSflAfterRemove(epi) {
            this.sflListContents = this.sflListContents.filter(item => item.epi != epi);
            this.updateSflUIState(this.sflListContents.length === 0);
            // console.log('this.sflListContents', this.sflListContents);
        }

        addEventListeners() {
            // Using bound methods for easier cleanup
            this.elements.popupBg?.addEventListener("click", this.closePopup);
            this.elements.closeBtn?.addEventListener("click", this.closePopup);
            this.elements.tabButtonWishlist?.addEventListener("click", this.handleTabWishlistClick);
            this.elements.tabButtonSfl?.addEventListener("click", this.handleTabSflClick);
            this.elements.continueShoppingBtn?.addEventListener("click", this.handleContinueShopping);
            this.elements.openCartBtn?.addEventListener("click", this.handleOpenCart);
            this.elements.backToWishlistsBtn?.addEventListener("click", this.backToWishlists.bind(this));
            this.elements.mobileBackToWishlistsBtn?.addEventListener("click", this.backToWishlists.bind(this));
            
            // Delegated event listeners for product grids
            this.elements.wishlistGrid?.addEventListener("click", this.handleProductCardClick);
            this.elements.sflGrid?.addEventListener("click", this.handleProductCardClick);

            // Add event listener for "Move All to Cart" button
            this.elements.sflMoveAllToCartButton?.addEventListener("click", this.handleMoveAllToCart.bind(this));

            this.elements.customProductNotifCloseBtn?.addEventListener("click", ()=>{
                this.elements.customProductNotifCloseBtn.closest('#swymcs-global-custom-notification').classList.add('swym-hide-container');
            })
        }

        // Improved fetch with error retry and better loading state management
        async fetchWishlist(retryCount = 0) {
            this.showLoading(true, SwymcsCustomWishlistPopup.TYPES.WISHLIST);
            try {
                // console.log('fetchWishlist called');
                if (!this.swat) {
                    console.error('Swym not initialized');
                    this.showError('Wishlist service not available');
                    return;
                }

                const lists = await new Promise((resolve, reject) => {
                    this.swat.fetchLists({
                        callbackFn: (lists) => resolve(lists),
                        errorFn: (error) => reject(error)
                    });
                });

                // console.log("Fetched all Lists", lists);
                this.lists = lists.filter(list => list.lty != 'sfl'); // Update the state with fetched lists
                if (this.lists.length === 0) {
                    this.elements.emptyWishlistContainer?.classList.remove("swym-hide-container");
                    this.elements.wishlistsTitle?.classList.add("swym-hide-container");
                } else {
                    this.elements.emptyWishlistContainer?.classList.add("swym-hide-container");
                    this.elements.wishlistsTitle?.classList.remove("swym-hide-container");
                    await this.renderWishlists();
                }
            } catch (error) {
                console.error("Error while fetching all Lists", error);
                // Add retry logic for network errors
                if (retryCount < 2 && error.name === 'NetworkError') {
                    console.log(`Retrying fetchWishlist (attempt ${retryCount + 1})`);
                    setTimeout(() => this.fetchWishlist(retryCount + 1), 1000);
                    return;
                }
                this.showError('Unable to load your wishlists');
            } finally {
                this.showLoading(false, SwymcsCustomWishlistPopup.TYPES.WISHLIST);
            }
        }

        async fetchSfl(retryCount = 0) {
            // Add explicit loading state for SFL
            this.showLoading(true, SwymcsCustomWishlistPopup.TYPES.SFL);
            
            // console.log('fetchSfl called');
            if (!this.swat || !this.sflListId) {
                console.error('Swym not initialized or SFL list ID not available');
                this.showLoading(false, SwymcsCustomWishlistPopup.TYPES.SFL);
            }

            try {
                const response = await new Promise((resolve, reject) => {
                    this.swat.SaveForLater.fetch(
                        this.sflListId,
                        (response) => {
                            this.sflListContents = response.items ? response.items : [];
                            resolve(response);
                        },
                        (error) => reject(error)
                    );
                });

                if (response.items && response.items.length > 0) {
                    await this.enrichProductData(response.items);
                }

                // console.log("Successfully Fetched Save for Later List with enriched data", response);
                
                if (!response.items || response.items.length == 0) {
                    this.elements.emptySflContainer?.classList.remove("swym-hide-container");
                    this.elements.sflGrid?.classList.add("swym-hide-container");
                    this.elements.sflHeader.classList.add("swym-hide-container");
                    
                    // Disable "Move All to Cart" button when no items
                    if (this.elements.sflMoveAllToCartButton) {
                        this.elements.sflMoveAllToCartButton.disabled = true;
                    }
                } else {
                    this.elements.emptySflContainer?.classList.add("swym-hide-container");
                    this.elements.sflGrid?.classList.remove("swym-hide-container");
                    this.elements.sflGrid.innerHTML = this.generateProductGridItems(response, SwymcsCustomWishlistPopup.TYPES.SFL);
                    this.elements.sflHeader.classList.remove("swym-hide-container");
                    
                    // Enable "Move All to Cart" button when items exist
                    if (this.elements.sflMoveAllToCartButton) {
                        this.elements.sflMoveAllToCartButton.disabled = false;
                    }
                }
            } catch (error) {
                console.log("Error while fetching Save For Later List", error);
                // Add retry logic for network errors
                if (retryCount < 2 && error.name === 'NetworkError') {
                    console.log(`Retrying fetchSfl (attempt ${retryCount + 1})`);
                    setTimeout(() => this.fetchSfl(retryCount + 1), 1000);
                    return;
                }
                this.showError('Unable to load your saved for later items');
            } finally {
                this.showLoading(false, SwymcsCustomWishlistPopup.TYPES.SFL);
            }
        }

        // Improved product data enrichment with caching
        async enrichProductData(items) {
            // Create an array of promises for parallel execution
            const productDetailPromises = items.map(item => {
                return new Promise((resolve) => {
                    // Use cached data if available
                    if (this.#productCache.has(item.du)) {
                        item.productData = this.#productCache.get(item.du);
                        resolve();
                        return;
                    }
                    
                    this.swat.getProductDetails({ du: item.du }, (data) => {
                        // Cache the product data
                        this.#productCache.set(item.du, data);
                        // Add the additional product data to the item
                        item.productData = data;
                        resolve();
                    });
                });
            });

            await Promise.all(productDetailPromises);
        }

        async openPopup() {
            // console.log("Opening popup");
            
            // Add fade-in class
            this.elements.popupContainer?.classList.add("fade-in");
            this.elements.popupContainer?.classList.remove("swym-hide-container");
            
            // Set focus to the popup for accessibility
            setTimeout(() => {
                this.elements.popupContainer?.setAttribute('tabindex', '-1');
                this.elements.popupContainer?.focus();
            }, 100);

            // Add event listener for Escape key to close the modal
            const handleKeyDown = (event) => {
                if (event.key === 'Escape') {
                    this.closePopup();
                    document.removeEventListener('keydown', handleKeyDown);
                }
            };
            
            document.addEventListener('keydown', handleKeyDown);

            // Reset loading indicators
            this.elements.wishlistLoadingIndicator?.classList.remove("swym-hide-container");
            this.elements.sflLoadingIndicator?.classList.remove("swym-hide-container");

            // Fetch data
            await Promise.all([
                this.fetchWishlist(),
                this.fetchSfl()
            ]);

            // Check if lists are available and update UI
            if (this.lists && this.lists.length > 0) {
                // console.log("Lists fetched successfully:", this.lists);
                this.elements.listsContainer.classList.remove("swym-hide-container");
                this.elements.emptyWishlistContainer.classList.add("swym-hide-container");
            } else {
                // console.log("No lists available");
                this.elements.listsContainer.classList.add("swym-hide-container");
                this.elements.emptyWishlistContainer.classList.remove("swym-hide-container");
            }

            // Ensure the loading indicators are hidden
            this.elements.wishlistLoadingIndicator?.classList.add("swym-hide-container");
            this.elements.sflLoadingIndicator?.classList.add("swym-hide-container");
        }

        populateListSwitcher(list) {
            // console.log('populateListSwitcher called');
            
            // Create select options using DocumentFragment for better performance
            const fragment = document.createDocumentFragment();
            const select = document.createElement('select');
            select.id = 'swymcs-list-switcher';
            
            // Remember the current list ID to maintain selection
            const currentListId = this.state.currentListId;
            
            this.lists.forEach(l => {
                const option = document.createElement('option');
                option.value = l.lid;
                option.textContent = `${l.lname} (${l.listcontents.length})`;
                
                // Set selected attribute if this is the current list
                if (l.lid === currentListId) {
                    option.selected = true;
                }
                
                select.appendChild(option);
            });
            
            fragment.appendChild(select);
            
            // Replace the existing list switcher - use listSwitchDiv as in the original code
            this.elements.listSwitchDiv.innerHTML = '';
            this.elements.listSwitchDiv.appendChild(fragment);
            
            // Add change event listener
            select.addEventListener('change', (e) => {
                const selectedList = this.lists.find(l => l.lid == e.target.value);
                if (!selectedList) return;
                
                // Update current list ID
                this.state.currentListId = selectedList.lid;
                
                // Clear and update wishlist grid
                this.elements.wishlistGrid.innerHTML = '';
                this.elements.wishlistGrid.innerHTML = this.generateProductGridItems(selectedList, SwymcsCustomWishlistPopup.TYPES.WISHLIST);
                
                // Attach event listeners
                this.attachButtonListeners(this.elements.wishlistGrid);
            });
            
            // Attach event listeners once here
            this.attachButtonListeners(this.elements.wishlistGrid);
        }

        switchTab(tabId) {
            // Update tab buttons
            this.querySelectorAll(".swymcs-tab-button")?.forEach(button => {
                button.classList.remove("swymcs-selected");
                button.setAttribute('aria-selected', 'false');
            });
            
            const selectedTab = this.querySelector(`#${tabId}`);
            selectedTab?.classList.add("swymcs-selected");
            selectedTab?.setAttribute('aria-selected', 'true');

            // Update tab content with ARIA attributes for accessibility
            if (tabId == SwymcsCustomWishlistPopup.TABS.WISHLIST) {
                this.elements.tabContentWishlist?.classList.remove("swym-hide-container");
                this.elements.tabContentSfl?.classList.add("swym-hide-container");
                this.elements.tabContentWishlist?.setAttribute('aria-hidden', 'false');
                this.elements.tabContentSfl?.setAttribute('aria-hidden', 'true');
            } else if (tabId == SwymcsCustomWishlistPopup.TABS.SFL) {
                this.elements.tabContentWishlist?.classList.add("swym-hide-container");
                this.elements.tabContentSfl?.classList.remove("swym-hide-container");
                this.elements.tabContentWishlist?.setAttribute('aria-hidden', 'true');
                this.elements.tabContentSfl?.setAttribute('aria-hidden', 'false');
            }
            
            // Update state
            this.state.currentTab = tabId === SwymcsCustomWishlistPopup.TABS.WISHLIST ? 
                SwymcsCustomWishlistPopup.TYPES.WISHLIST : 
                SwymcsCustomWishlistPopup.TYPES.SFL;
        }

        backToWishlists() {
            this.elements.wishlistsTitle?.classList.remove("swym-hide-container");
            this.elements.listsContainer?.classList.remove("swym-hide-container");
            this.elements.wishlistsItemsContainer?.classList.add("swym-hide-container");
            
            // Update state
            this.state.currentListId = null;
            this.renderWishlists();

            if(this.lists && this.lists.length > 0) {
                this.elements.emptyWishlistContainer?.classList.add("swym-hide-container");
            }
        }

        updateListDetails(updatedListObj) {
            let listToUpdate = this.lists.find(list => list.lid == updatedListObj.lid);
            listToUpdate.lname = updatedListObj.lname;
            this.backToWishlists();
        }

        renderListDetails(listId) {
            // console.log('renderListDetails called with listId:', listId);
            const currentList = this.lists.find(list => list.lid == listId);
            this.elements.renameListName.placeholder = currentList.lname;
            // console.log('Found list:', currentList);
            
            if (!currentList) {
                console.error('List not found:', listId);
                return;
            }
            
            // Update UI state - use a batch update approach
            const updateUI = () => {
                this.elements.wishlistsTitle?.classList.add("swym-hide-container");
                this.elements.listsContainer?.classList.add("swym-hide-container");
                this.elements.wishlistsItemsContainer?.classList.remove("swym-hide-container");
                this.elements.wishlistGrid.setAttribute("listId", listId);
                
                const option = this.elements.listSwitchDiv.querySelector(`option[value="${listId}"]`);
                if (option) option.selected = true;
                
                // Generate product grid
                this.elements.wishlistGrid.innerHTML = this.generateProductGridItems(currentList, SwymcsCustomWishlistPopup.TYPES.WISHLIST);
            };
            
            // Use requestAnimationFrame for smoother UI updates
            requestAnimationFrame(updateUI);
            
            // Update state
            this.state.currentListId = listId;
        }

        async renderWishlists() {
            // console.log('renderWishlists called');
            // clear the current listsContainer
            this.elements.listsContainer.innerHTML = '';
            try {
                // Only fetch if we don't have lists
                if (!this.lists) {
                    this.lists = await this.fetchWishlist();
                }

                if (!this.lists || this.lists.length == 0) {
                    this.elements.emptyWishlistContainer?.classList.remove("swym-hide-container");
                    return;
                }

                // Enrich product data for all items in all lists
                for (const list of this.lists) {
                    if (list.listcontents && list.listcontents.length > 0 && !list.listcontents[0].productData) {
                        await this.enrichProductData(list.listcontents);
                    }
                }

                // Populate the list switcher after all data is fetched and enriched
                this.populateListSwitcher(this.lists); // Pass the first list as default

                this.elements.emptyWishlistContainer?.classList.add("swym-hide-container");
                
                if (this.elements.listsContainer) {
                    // Use DocumentFragment for better performance
                    const fragment = document.createDocumentFragment();
                    const viewListCTA = this.Strings.ViewListCTA
                    this.lists.forEach(list => {
                        const listItem = document.createElement('div');
                        listItem.classList.add('swymcs-wishlist-item');
                        listItem.innerHTML = `
                            <div class="swymcs-list-container">
                                <span class="swymcs-wishlist-name swymcs-list-tile-text">${list.lname}</span>
                                <span class="swymcs-wishlist-count swymcs-list-tile-text">${list.listcontents.length}${list.listcontents.length == 1 ? ' Product' : ' Products'} </span>
                                <div class="swymcs-list-images">
                                    ${this.generateImageGrid(list.listcontents)}
                                </div>
                                <button listId="${list.lid}" class="swymcs-view-list-btn swymcs-primary-font">${viewListCTA}</button>
                            </div>  
                        `;
                        
                        // Add event listener before appending to improve performance
                        const viewListBtn = listItem.querySelector(".swymcs-view-list-btn");
                        viewListBtn.addEventListener("click", () => this.renderListDetails(list.lid));
                        
                        fragment.appendChild(listItem);
                    });
                    
                    let createListCTA = this.Strings.AddWishlistPopupCTAAddNew;
                    const newListCard = document.createElement('div');
                    newListCard.classList.add('swymcs-wishlist-item');
                    newListCard.classList.add('swymcs-newlist-card');
                    newListCard.innerHTML =   `
                    <div class="swymcs-list-container">
                    <span class="swymcs-wishlist-name swymcs-list-tile-text"></span>
                    <span class="swymcs-wishlist-count swymcs-list-tile-text"></span>
                    <div class="swymcs-list-images"></div>
                    <button class="swymcs-view-list-btn swymcs-create-list-btn swymcs-primary-font" style="margin:unset">${createListCTA}</button>
                    </div>`
                    newListCard.addEventListener('click', () => this.toggleModal('createList', true, {}));
                    // Clear and update in one operation
                    this.elements.listsContainer.innerHTML = '';
                    this.elements.listsContainer.appendChild(fragment);
                    this.elements.listsContainer.appendChild(newListCard);
                }
            } catch (error) {
                console.error('Error rendering wishlists:', error);
                this.showError('Failed to render wishlists');
            }
        }

        generateImageGrid(listContents) {
            // Check if mobile view (max-width: 768px)
            const isMobile = window.matchMedia('(max-width: 768px)').matches;
            const maxImages = isMobile ? 3 : 4;
            let html = '';
            
            // Ensure listContents is an array (even if empty)
            const contents = Array.isArray(listContents) ? listContents : [];

            // Add product images or placeholders for each slot
            for (let i = 0; i < maxImages; i++) {
                if (i < contents.length && contents[i].iu) {
                    // Product image with loading="lazy" for better performance
                    html += `
                        <div class="swymcs-list-image-item">
                            <img width="85px" height="127.5px" class="swymcs-list-image" 
                                src="${contents[i].iu}" 
                                alt="${contents[i].dt || 'Product image'}" 
                                loading="lazy">
                        </div>`;
                } else {
                    // Placeholder for empty slot
                    html += `
                        <div class="swymcs-list-image-item swymcs-list-image-placeholder">
                            <!-- Empty placeholder -->
                        </div>`;
                }
            }

            return html;
        }

        generateProductGridItems(response, type) {
            if (!response) {
                console.error('No response data provided to generateProductGridItems');
                return '';
            }
            
            let listContents;
            let listId;
            
            if(type == SwymcsCustomWishlistPopup.TYPES.SFL) {
                listContents = response.items || [];
                listId = response.list?.lid;
            } else if (type == SwymcsCustomWishlistPopup.TYPES.WISHLIST) {
                listContents = response.listcontents || [];
                listId = response.lid;
            } else {
                console.error('Invalid product type:', type);
                return '';
            }
            
            if(!listId) {
                console.error('No list ID found in response');
                return '';
            }
            this.elements.shareListBtn.removeAttribute("disabled");
            
            // Check if list is empty and handle appropriately based on type
            if(listContents.length == 0) {
                if(type == SwymcsCustomWishlistPopup.TYPES.WISHLIST) {
                    this.elements.emptyWishlistContainer?.classList.remove("swym-hide-container");
                    this.elements.wishlistGrid?.classList.add("swym-hide-container");
                    // disable the clear list button
                    this.elements.clearListButton.setAttribute("disabled", "disabled");
                    // disable the share button
                    this.elements.shareListBtn.setAttribute("disabled", "disabled");
                } else if(type == SwymcsCustomWishlistPopup.TYPES.SFL) {
                    this.elements.emptySflContainer?.classList.remove("swym-hide-container");
                    this.elements.sflGrid?.classList.add("swym-hide-container");
                }
                return '';
            } else {
                if(type == SwymcsCustomWishlistPopup.TYPES.WISHLIST) {
                    this.elements.emptyWishlistContainer?.classList.add("swym-hide-container");
                    this.elements.wishlistGrid?.classList.remove("swym-hide-container");
                    // enable the clear list button
                    this.elements.clearListButton.removeAttribute("disabled");
                    // enable the share button
                    this.elements.shareListBtn.removeAttribute("disabled");
                } else if(type == SwymcsCustomWishlistPopup.TYPES.SFL) {
                    this.elements.emptySflContainer?.classList.add("swym-hide-container");
                    this.elements.sflGrid?.classList.remove("swym-hide-container");
                }
            }

            // Use an array for better performance than string concatenation
            const productCards = [];
            
            listContents.forEach(item => {
                productCards.push(this.renderProductCard(item, type, listId));
            });

            return productCards.join('');
        }

        attachButtonListeners(container) {
            // console.log('attachButtonListeners called');
            // Event delegation is already implemented in handleProductCardClick
            // This method is kept for backward compatibility but doesn't need to add listeners anymore
        }

        async deleteFromWishlist(listId, product) {
            // console.log('deleteFromWishlist called:', { listId, product });
            if (!this.swat) {
                console.error('Swym not initialized');
                return Promise.reject(new Error('Swym not initialized'));
            }

            return new Promise((resolve, reject) => {
                this.swat.deleteFromList(
                    listId, 
                    {
                        epi: product.epi,
                        empi: product.empi,
                        du: product.du
                    },
                    (deletedProduct) => {
                        // console.log("Successfully deleted the Product", deletedProduct);
                        resolve(deletedProduct);
                    },
                    (error) => {
                        console.error("Error while deleting the Product", error);
                        reject(error);
                    }
                );
            });
        }

        async deleteFromSfl(product) {
            // console.log('deleteFromSfl called:', product);
            if (!this.swat || !this.sflListId) {
                const error = new Error('Swym not initialized or SFL list ID not available');
                console.error(error.message);
                return Promise.reject(error);
            }

            return new Promise((resolve, reject) => {
                this.swat.SaveForLater.remove(
                    this.sflListId,
                    [{
                        du: product.du,
                        empi: product.empi,
                        epi: product.epi
                    }],
                    (response) => {
                        // console.log("Successfully removed from SFL", response);
                        resolve(response);
                    },
                    (error) => {
                        console.error("Error removing from SFL", error);
                        reject(error);
                    }
                );
            });
        }

        async addToCart(product) {
            // console.log('addToCart called with product:', product);
            return new Promise((resolve, reject) => {
                this.swat.replayAddToCart(
                    { 
                        empi: product.empi, 
                        du: product.du, 
                        qty: 1  // Assuming a default quantity of 1; adjust as needed
                    },
                    product.epi,
                    (success) => {
                        const variant = JSON.parse(success).items[0];
                        const productTitle = variant.title;
                        let successMessage = `<strong>${productTitle}</strong> has been added to cart!`;
                        // ajaxCart.load(false, false);
                        ajaxCart.load(false, false, false, true, false);
                        // Show success notification
                        // this.swat.ui.uiRef.showSuccessNotification({ message: successMessage });
                        resolve(success);
                    },
                    (error) => {
                        // Show error notification
                        let html = `<div class="swymcs-notif-container">
                        ${this.elements.errorIcon}<span>${error.description}</span>
                        </div>`;
                        this.swat.ui.uiRef.showNotification({message: `${html}`});
                        reject(error);
                    }
                );
            });
        }
        updateWishlistUIState(isEmpty) {
            // Batch DOM updates for better performance
            requestAnimationFrame(() => {
                if(isEmpty) {
                    this.elements.emptyWishlistContainer?.classList.remove("swym-hide-container");
                    this.elements.wishlistGrid?.classList.add("swym-hide-container");
                    this.elements.wishlistsTitle?.classList.add("swym-hide-container");
                } else {
                    this.elements.emptyWishlistContainer?.classList.add("swym-hide-container");
                    this.elements.wishlistGrid?.classList.remove("swym-hide-container");
                    this.elements.wishlistsTitle?.classList.remove("swym-hide-container");
                }
            });
            
            // Update state
            this.state.lists = this.lists || [];
        }

        updateSflUIState(isEmpty) {
            // Batch DOM updates for better performance
            requestAnimationFrame(() => {
                if(isEmpty) {
                    this.elements.emptySflContainer?.classList.remove("swym-hide-container");
                    this.elements.sflGrid?.classList.add("swym-hide-container");
                    this.elements.sflHeader?.classList.add("swym-hide-container");
                } else {
                    this.elements.emptySflContainer?.classList.add("swym-hide-container");
                    this.elements.sflGrid?.classList.remove("swym-hide-container");
                    this.elements.sflHeader?.classList.remove("swym-hide-container");
                }
            });
            
            // Update state
            this.state.sflItems = this.sflListContents || [];
        }

        showError(message) {
            console.error(message);
            // Display user-friendly error notification using Swym's notification system
            let html = '<div class="swymcs-notif-container">' + 
                this.elements.errorIcon + '<span>' + message + '</span></div>';
            if (this.swat?.ui?.uiRef) {
                this.swat.ui.uiRef.showNotification({message: `${html}`});
                // this.swat.ui.uiRef.showErrorNotification({ message });
            }
        }

        // Improved state management with render method
        updateState(changes) {
            // Update state
            Object.assign(this.state, changes);
            
            // Trigger UI updates based on state changes
            if (changes.currentTab !== undefined) {
                this.updateTabUI(changes.currentTab);
            }
            
            if (changes.currentListId !== undefined) {
                this.updateCurrentListUI(changes.currentListId);
            }
            
            // Fire a custom event so other components can react
            this.dispatchEvent(new CustomEvent('swymcs-state-updated', {
                detail: { changes, state: this.state }
            }));
        }

        // Improved debounce utility
        debounce(func, wait = 300) {
            let timeout;
            return function executedFunction(...args) {
                const context = this;
                const later = () => {
                    clearTimeout(timeout);
                    func.apply(context, args);
                };
                clearTimeout(timeout);
                timeout = setTimeout(later, wait);
            };
        }

        showLoading(isLoading, type) {
            const loadingElement = type === SwymcsCustomWishlistPopup.TYPES.WISHLIST ? 
                this.elements.wishlistLoadingIndicator : 
                this.elements.sflLoadingIndicator;
            
            // Update state
            this.state.isLoading = {
                ...this.state.isLoading,
                [type]: isLoading
            };
            
            // Batch DOM updates for better performance
            requestAnimationFrame(() => {
                if (isLoading) {
                    // Show loading indicator
                    loadingElement?.classList.remove("swym-hide-container");
                    
                    // Hide content while loading
                    if (type === SwymcsCustomWishlistPopup.TYPES.WISHLIST) {
                        // Hide all wishlist-related containers
                        this.elements.listsContainer?.classList.add("swym-hide-container");
                        this.elements.wishlistsItemsContainer?.classList.add("swym-hide-container");
                        this.elements.emptyWishlistContainer?.classList.add("swym-hide-container");
                        this.elements.wishlistsTitle?.classList.add("swym-hide-container");
                    } else {
                        // Hide all SFL-related containers
                        this.elements.sflGrid?.classList.add("swym-hide-container");
                        this.elements.emptySflContainer?.classList.add("swym-hide-container");
                        this.elements.sflHeader?.classList.add("swym-hide-container");
                    }
                } else {
                    // Hide loading indicator when loading is complete
                    loadingElement?.classList.add("swym-hide-container");
                    
                    // Note: Actual content visibility is managed by fetchWishlist() and fetchSfl()
                    // methods after they determine if there's content to show
                }
            });
        }

        initShareAndAdditionalOptionsPopup() {
            // Initialize elements
            this.elements.sharePopup = this.querySelector('#swymcs-share-popup');
            this.elements.shareForm = this.querySelector('#swymcs-share-form');
            this.elements.shareCloseBtn = this.querySelector('.swymcs-share-popup-close');
            this.elements.copyLinkBtn = this.querySelector('#swymcs-copy-link-btn');
            this.elements.facebookShareBtn = this.querySelector('#swymcs-facebook-share-btn');
            this.elements.twitterShareBtn = this.querySelector('#swymcs-twitter-share-btn');
            this.elements.shareListBtn = this.querySelector('#swymcs-list-share-btn');
            
            // Add event listeners
            if (this.elements.shareListBtn) {
                this.elements.shareListBtn.addEventListener('click', () => this.openSharePopup());
            }
            
            if (this.elements.shareCloseBtn) {
                this.elements.shareCloseBtn.addEventListener('click', () => this.closeSharePopup());
            }
            
            if (this.elements.sharePopupBg) {
                this.elements.sharePopupBg.addEventListener('click', () => this.closeSharePopup());
            }

            if (this.elements.shareForm) {
                this.elements.shareForm.addEventListener('submit', (e) => this.handleShareList(e));
            }
            
            if (this.elements.copyLinkBtn) {
                this.elements.copyLinkBtn.addEventListener('click', () => this.handleCopyLink());
            }
            
            if (this.elements.facebookShareBtn) {
                this.elements.facebookShareBtn.addEventListener('click', () => this.handleShareFacebook());
            }
            
            if (this.elements.twitterShareBtn) {
                this.elements.twitterShareBtn.addEventListener('click', () => this.handleShareTwitter());
            }

            if (this.elements.confirmCreateNewListButton) {
                this.elements.confirmCreateNewListButton.addEventListener('click', () => this.createNewList(this.elements.createNewListName.value));
            }   

            if (this.elements.confirmRenameListButton) {
                this.elements.confirmRenameListButton.addEventListener('click', () => this.renameList(this.elements.renameListName.value));
            }   
            // if (this.elements.createNewListCard) {
            //     this.elements.createNewListCard.addEventListener('click', () => this.toggleModal('createList', true));
            // }   

            if (this.elements.closeCreateNewListButton) {
                this.elements.closeCreateNewListButton.addEventListener('click', () => this.toggleModal('createList', false));
            }
            if (this.elements.closeRenameListButton) {
                this.elements.closeRenameListButton.addEventListener('click', () => this.toggleModal('renameList', false));
            }
            
            if (this.elements.createNewListBg) {
                this.elements.createNewListBg.addEventListener('click', () => this.toggleModal('createList', false));
            }
            if (this.elements.renameListBg) {
                this.elements.renameListBg.addEventListener('click', () => this.toggleModal('renameList', false));
            }

            if (this.elements.additionalOptionsButton) {
                this.elements.additionalOptionsButton.addEventListener('click', () => this.openAdditionalOptions());
            }

            // Add event listeners for confirmation modal
            this.elements.confirmYes.addEventListener('click', () => this.handleConfirmationResponse(true));
            this.elements.confirmNo.addEventListener('click', () => this.handleConfirmationResponse(false));

            // Add event listeners for clear and delete buttons
            this.elements.clearListButton.addEventListener('click', () => this.openConfirmationModal('clear'));
            this.elements.deleteListButton.addEventListener('click', () => this.openConfirmationModal('delete'));
            this.elements.createNewListButton.addEventListener('click', () => this.toggleModal('createList', true, {}));
            this.elements.renameListButton.addEventListener('click', () => this.toggleModal('renameList', true, {}));
            // Make sure the confirmation "No" button also closes everything properly
            this.elements.confirmNo?.addEventListener('click', () => {
                this.elements.confirmationModal.classList.add('swym-hide-container');
                this.elements.additionalOptionsBackground.classList.add('swym-hide-container');
            });
            
            // Ensure share popup close button works correctly
            this.elements.shareCloseBtn?.addEventListener('click', () => {
                this.elements.sharePopup.classList.add('swym-hide-container');
                this.elements.additionalOptionsBackground.classList.add('swym-hide-container');
            });
        }

        //add event listeners for additional options
       handleBackgroundClick() {
        // Handle background clicks to close popups
        this.elements.additionalOptionsBackground?.addEventListener('click', (e) => {
            // Only close if the click was directly on the background (not its children)
            if (e.target === this.elements.additionalOptionsBackground) {
                // Close additional options popup
                this.elements.additionalOptionsContainer?.classList.add('swym-hide-container');
                
                // Close confirmation modal
                this.elements.confirmationModal?.classList.add('swym-hide-container');
                
                // Close share popup if it's open
                this.elements.sharePopup?.classList.add('swym-hide-container');
                
                // Hide the background itself
                this.elements.additionalOptionsBackground?.classList.add('swym-hide-container');
            }
        });
       }

        openAdditionalOptions() {
            this.elements.additionalOptionsBackground.classList.remove('swym-hide-container');
            this.elements.additionalOptionsContainer.classList.remove('swym-hide-container');
            this.elements.additionalOptionsContainer.classList.add('swym-active-popup');
        }

        closeAdditionalOptions() {
            this.elements.additionalOptionsBackground.classList.add('swym-hide-container');
            this.elements.additionalOptionsContainer.classList.add('swym-hide-container');
            this.elements.additionalOptionsContainer.classList.remove('swym-active-popup');
        }

        openSharePopup() {
            this.toggleModal('share', true);
        }

        closeSharePopup() {
            this.toggleModal('share', false);
        }

        getCurrentListName() {
            if (!this.state.currentListId) return '';
            
            if (this.state.currentTab === SwymcsCustomWishlistPopup.TYPES.SFL) {
                return 'Saved For Later';
            } else {
                const list = this.lists.find(l => l.lid === this.state.currentListId);
                return list ? list.lname : '';
            }
        }

        async handleShareList(e) {
            e.preventDefault();
            
            const senderNameInput = this.querySelector('#swymcs-sender-name');
            const recipientEmailInput = this.querySelector('#swymcs-recipient-email');
            const messageInput = this.querySelector('#swymcs-share-message');
            const submitBtn = this.querySelector('#swymcs-share-list-submit');
            
            // Validate required fields
            if (!recipientEmailInput || !recipientEmailInput.value) {
                let html = `<div class="swymcs-notif-container">
                        ${this.elements.errorIcon}<span>${this.Strings.ValidationErrorEmail}</span>
                        </div>`;
                        this.swat.ui.uiRef.showNotification({message: `${html}`});
                recipientEmailInput?.focus();
                return;
            }
            
            if (!this.shareListData?.lid) {
                let html = `<div class="swymcs-notif-container" >
                    ${this.elements.errorIcon}<span>${this.Strings.SharedWishlistEmptyText}</span>
                    </div>`;
                    this.swat.ui.uiRef.showNotification({message: `${html}`});
                // this.swat.ui.uiRef.showErrorNotification({ message: 'No list selected for sharing' });
                return;
            }
            
            // Get form data
            const shareData = {
                fromName: senderNameInput?.value || 'A friend',
                toEmailId: recipientEmailInput.value,
                note: messageInput?.value || `Check out my ${this.getCurrentListName()} list!`,
                lid: this.shareListData.lid,
                cprops: {}
            };
            
            try {
                // Show loading state
                if (submitBtn) {
                    submitBtn.textContent = 'Sharing...';
                    submitBtn.disabled = true;
                }
                
                // First make list public
                await this.markListPublic(this.shareListData.lid);
                
                // Call Swym API to share list via email
                await this.shareWishlistViaEmail(shareData);
                
                // Show success message
                let html = `<div class="swymcs-notif-container" >
                        ${this.elements.successIcon}<span>${this.Strings.ShareWishlistEmailSuccess}</span>
                        </div>`;
                        this.swat.ui.uiRef.showNotification({message: `${html}`});
                this.closeSharePopup();
            } catch (err) {
                console.error('Failed to share list:', err);
                let html = `<div class="swymcs-notif-container" >
                    ${this.elements.errorIcon}<span>${this.Strings.ShareWishlistEmailError}</span>
                    </div>`;
                    this.swat.ui.uiRef.showNotification({message: `${html}`});
                // this.swat.ui.uiRef.showErrorNotification({ message: 'Failed to share list. Please try again.' });
            } finally {
                // Reset button state
                if (submitBtn) {
                    submitBtn.textContent = 'SHARE LIST';
                    submitBtn.disabled = false;
                }
            }
        }

        async markListPublic(lid) {
            if (!lid) {
                throw new Error(SwymcsCustomWishlistPopup.CONFIG.ERROR_MESSAGES.LIST_ID_REQUIRED);
            }
            
            try {
                return await this.apiCall('markListPublic', lid);
            } catch (error) {
                this.handleError(error, 'mark list public');
                throw error;
            }
        }

        async getSharedListURL(lid) {
            if (!lid) {
                throw new Error(SwymcsCustomWishlistPopup.CONFIG.ERROR_MESSAGES.LIST_ID_REQUIRED);
            }
            
            try {
                return await this.apiCall('generateSharedListURL', lid);
            } catch (error) {
                this.handleError(error, 'generate shared URL');
                throw error;
            }
        }

        async shareWishlistViaEmail(params) {
            try {
                return await this.apiCall('sendListViaEmail', params);
            } catch (error) {
                this.handleError(error, 'share list via email');
                throw error;
            }
        }

        async handleCopyLink() {
            if (!this.shareListData?.lid) {
                let html = `<div class="swymcs-notif-container" >
                    ${this.elements.errorIcon}<span>${this.Strings.SharedWishlistEmptyText}</span>
                    </div>`;
                    this.swat.ui.uiRef.showNotification({message: `${html}`});
                // this.swat.ui.uiRef.showErrorNotification({ message: 'No list selected for sharing' });
                return;
            }
            
            try {
                // First make the list public
                await this.markListPublic(this.shareListData.lid);
                
                // Get the shareable URL
                const shareUrl = await this.getSharedListURL(this.shareListData.lid);
                
                // Copy to clipboard
                const textArea = document.createElement('textarea');
                textArea.value = shareUrl;
                textArea.style.position = 'fixed';
                textArea.style.opacity = 0;
                document.body.appendChild(textArea);
                textArea.select();
                document.execCommand('copy');
                document.body.removeChild(textArea);
                
                // Show success notification
                let html = '<div class="swymcs-notif-container">' + 
                this.elements.successIcon + '<span>' + 
                this.Strings.ShareWishlistCopylinkSuccess.replace(
                    /{{{?wishlistName}?}}/g, 
                    this.shareListData.lname) + '</span></div>';
                this.swat.ui.uiRef.showNotification({message: `${html}`});
            } catch (err) {
                console.error('Failed to copy link:', err);
                let html = `<div class="swymcs-notif-container" >
                    ${this.elements.errorIcon}<span>${this.Strings.ShareWishlistCopylinkError}</span>
                    </div>`;
                    this.swat.ui.uiRef.showNotification({message: `${html}`});
                // this.swat.ui.uiRef.showErrorNotification({ message: 'Failed to copy link. Please try again.' });
            }
        }

        async handleShareFacebook() {
            if (!this.shareListData?.lid) {
                let html = `<div class="swymcs-notif-container" >
                    ${this.elements.errorIcon}<span>${this.Strings.SharedWishlistEmptyText}</span>
                    </div>`;
                    this.swat.ui.uiRef.showNotification({message: `${html}`});
                // this.swat.ui.uiRef.showErrorNotification({ message: 'No list selected for sharing' });
                return;
            }
            
            try {
                // First make the list public
                await this.markListPublic(this.shareListData.lid);
                
                const fromName = this.querySelector('#swymcs-sender-name')?.value || 'A friend';
                const note = this.querySelector('#swymcs-share-message')?.value || `Check out my ${this.getCurrentListName()} list!`;
                const platformShareUrlTemplate = "https://www.facebook.com/sharer.php?u={{shareurl}}&t={{note}}";
                const platform = "facebook";
                
                this.swat.shareListSocial(
                    this.shareListData.lid,
                    fromName,
                    platformShareUrlTemplate,
                    platform,
                    note,
                    (error) => {
                        console.error('Error sharing to Facebook:', error);
                        let html = `<div class="swymcs-notif-container" >
                    ${this.elements.errorIcon}<span>${this.Strings.ShareWishlistEmailError}</span>
                    </div>`;
                    this.swat.ui.uiRef.showNotification({message: `${html}`});
                        // this.swat.ui.uiRef.showErrorNotification({ message: 'Failed to share to Facebook. Please try again.' });
                    }
                );
            } catch (err) {
                console.error('Failed to share to Facebook:', err);
                let html = `<div class="swymcs-notif-container" >
                    ${this.elements.errorIcon}<span>${this.Strings.ShareWishlistEmailError}</span>
                    </div>`;
                    this.swat.ui.uiRef.showNotification({message: `${html}`});
                // this.swat.ui.uiRef.showErrorNotification({ message: 'Failed to share to Facebook. Please try again.' });
            }
        }

        async handleShareTwitter() {
            if (!this.shareListData?.lid) {
                let html = `<div class="swymcs-notif-container" >
                    ${this.elements.errorIcon}<span>${this.Strings.ShareWishlistEmailError}</span>
                    </div>`;
                    this.swat.ui.uiRef.showNotification({message: `${html}`});
                // this.swat.ui.uiRef.showErrorNotification({ message: 'No list selected for sharing' });
                return;
            }
            
            try {
                // First make the list public
                await this.markListPublic(this.shareListData.lid);
                
                const fromName = this.querySelector('#swymcs-sender-name')?.value || 'A friend';
                const note = this.querySelector('#swymcs-share-message')?.value || `Check out my ${this.getCurrentListName()} list!`;
                const platformShareUrlTemplate = "https://twitter.com/intent/tweet?text={{note}}&url={{shareurl}}";
                const platform = "twitter";
                
                this.swat.shareListSocial(
                    this.shareListData.lid,
                    fromName,
                    platformShareUrlTemplate,
                    platform,
                    note,
                    (error) => {
                        console.error('Error sharing to Twitter:', error);
                        let html = `<div class="swymcs-notif-container" >
                    ${this.elements.errorIcon}<span>${this.Strings.ShareWishlistEmailError}</span>
                    </div>`;
                    this.swat.ui.uiRef.showNotification({message: `${html}`});
                        // this.swat.ui.uiRef.showErrorNotification({ message: 'Failed to share to Twitter. Please try again.' });
                    }
                );
            } catch (err) {
                console.error('Failed to share to Twitter:', err);
                let html = `<div class="swymcs-notif-container" >
                    ${this.elements.errorIcon}<span>${this.Strings.ShareWishlistEmailError}</span>
                    </div>`;
                    this.swat.ui.uiRef.showNotification({message: `${html}`});
                // this.swat.ui.uiRef.showErrorNotification({ message: 'Failed to share to Twitter. Please try again.' });
            }
        }

        renameList(lname){
            let nameIsUnique = true;
            this.lists.some((list) => {
                if (list.lname === lname) {
                  nameIsUnique = false;
                  return true; // stops the iteration
                }
                return false;
              });

            if(lname.length < 3){
                console.error("List length must be greater than 3 characters ;long");
                this.swat.ui.uiRef.showNotification();
                this.toggleModal('createList', false);
            }else if(!nameIsUnique){
                console.error("List name must be unique");
                this.swat.ui.uiRef.showNotification();
                this.toggleModal('createList', false);
            }else{
                const config = {
                    lid: this.state.currentListId,
                    lname: lname,
                    lnote: ''
                }
                const updateList = new Promise((res, rej)=>{
                    this.swat.updateList(config, (success)=>{res(success)}, (err)=>{rej(err)})
                })
                updateList.then((response)=>{
                    // console.log("List updated", response);
                    this.toggleModal('renameList', false);
                    this.toggleModal('additionalOptions', false);
                    this.updateListDetails(response);
                }).catch((error)=>{
                    console.error("Error occurred", error);
                })
            }
        }

        async createNewList(lname){
            let nameIsUnique = true;
            this.lists.some((list) => {
                if (list.lname === lname) {
                  nameIsUnique = false;
                  return true; // stops the iteration
                }
                return false;
              });

            if(lname.length < 3){
                console.error("List length must be greater than 3 characters ;long");
                this.swat.ui.uiRef.showNotification();
                this.toggleModal('createList', false);
            }else if(!nameIsUnique){
                console.error("List name must be unique");
                this.swat.ui.uiRef.showNotification();
                this.toggleModal('createList', false);
            }else{
                const config = {
                    lname: lname
                }
                const createList = new Promise((res, rej)=>{
                    this.swat.createList(config, (success)=>{res(success)}, (err)=>{rej(err)})
                })
                try {
                    const success = await createList;
                    // console.log("New List created", success);
                    this.toggleModal('createList', false);
                    this.toggleModal('additionalOptions', false);
                    this.closePopup();
                    this.openPopup();
                } catch (error) {
                    console.error("Error in list creation flow:", error);
                }
            }
        }
        openConfirmationModal(actionType) {
            this.toggleModal('confirmation', true, { actionType });
        }

        closeConfirmationModal() {
            this.elements.confirmationModal?.classList.add('swym-hide-container');
            
            // Close the background only if additional options isn't open
            if (this.elements.additionalOptionsContainer?.classList.contains('swym-hide-container')) {
                this.elements.additionalOptionsBackground?.classList.add('swym-hide-container');
            }
        }

        handleConfirmationResponse(isConfirmed) {
            if (isConfirmed) {
                if (this.currentActionType === 'delete') {
                    this.deleteCurrentList();
                } else if (this.currentActionType === 'clear') {
                    this.clearCurrentList();
                }
            }
            this.closeConfirmationModal();
            // Hide additional options background and additional options container
            this.elements.additionalOptionsBackground?.classList.add('swym-hide-container');
            this.elements.additionalOptionsContainer?.classList.add('swym-hide-container');
        }

        deleteCurrentList() {
            const lid = this.state.currentListId;
            if (!lid) {
                console.error('No list selected for deletion');
                return;
            }

            this.swat.deleteList(lid, 
                (deletedListObj) => {
                    // console.log(`Successfully deleted the List, ${lid}`, deletedListObj);
                    let listDeleteText ='<span>The list <strong>lname</strong> has been successfully deleted!</span>'
                    if(window.Shopify.locale == 'nl'){
                        listDeleteText = '<span>De lijst <strong>lname</strong> is succesvol verwijderd!</span>'
                    }else if(window.Shopify.locale == 'de'){
                        listDeleteText = '<span>Die Liste <strong>lname</strong> wurde erfolgreich gelöscht!</span>'
                    }
                    let html = '<div class="swymcs-notif-container">' + 
                    this.elements.successIcon + listDeleteText.replace('lname', deletedListObj.lname)+ '</div>';
                    this.swat.ui.uiRef.showNotification({message: `${html}`});
                    // let successMessage = `The list <strong>${deletedListObj.lname}</strong> has been <strong>deleted</strong>`
                    // this.swat.ui.uiRef.showSuccessNotification({ message: successMessage });
                    // Update this.lists to remove the deleted list
                    this.lists = this.lists.filter(list => list.lid !== lid);
                    this.renderWishlists();
                    
                    // Clear the current list ID
                    this.state.currentListId = null;
                    
                    // Hide list details view and show the wishlists container view
                    this.elements.wishlistsItemsContainer?.classList.add("swym-hide-container");
                    this.elements.listsContainer?.classList.remove("swym-hide-container");
                    this.elements.wishlistsTitle?.classList.remove("swym-hide-container");
                    
                    // Update list switcher
                    this.populateListSwitcher(this.lists);
                    
                    // Hide additional options background
                    this.elements.additionalOptionsBackground.classList.add('swym-hide-container');
                    this.elements.additionalOptionsContainer?.classList.add("swym-hide-container");
                    
                    // Show empty container if no lists remain
                    if (this.lists.length === 0) {
                        this.elements.emptyWishlistContainer?.classList.remove("swym-hide-container");
                        this.elements.wishlistsTitle?.classList.add("swym-hide-container");
                    }
                },
                (error) => {
                    console.error(`Error while deleting the List, ${lid}`, error);
                    this.showError('Failed to delete the list. Please try again.');
                }
            );
        }

        clearCurrentList() {
            const lid = this.state.currentListId;
            if (!lid) {
                console.error('No list selected for clearing');
                return;
            }

            const list = this.lists.find(l => l.lid === lid);
            if (!list || !list.listcontents) {
                console.error('No products found in the list');
                return;
            }

            // Remove all product cards from the DOM
            this.elements.wishlistGrid.innerHTML = '';
            this.elements.wishlistGrid.classList.add('swym-hide-container');

            // Call delete API for each product in the list
            const deletePromises = list.listcontents.map(product => {
                return new Promise((resolve, reject) => {
                    this.swat.deleteFromList(
                        lid, 
                        {
                            epi: product.epi,
                            empi: product.empi,
                            du: product.du
                        },
                        (deletedProduct) => {
                            // console.log("Successfully deleted the Product", deletedProduct);
                            resolve(deletedProduct);
                        },
                        (error) => {
                            console.error("Error while deleting the Product", error);
                            reject(error);
                        }
                    );
                });
            });

            Promise.all(deletePromises)
                .then(() => {
                    // console.log(`Successfully cleared all items from the List, ${lid}`);
                    
                    // Update this.lists to reflect the cleared list
                    const listIndex = this.lists.findIndex(l => l.lid === lid);
                    if (listIndex !== -1) {
                        this.lists[listIndex].listcontents = [];

                    }

                    this.populateListSwitcher(this.lists);

                    // Hide additional options background and show empty wishlists container
                    this.elements.additionalOptionsBackground.classList.add('swym-hide-container');
                    this.elements.emptyWishlistContainer.classList.remove('swym-hide-container');
                })
                .catch(error => {
                    console.error(`Error while clearing items from the List, ${lid}`, error);
                    this.showError('Failed to clear some items from the list. Please try again.');
                });
        }

        deleteProductFromList(lid, epi, onSuccess, onError) {
            // Assuming this method exists in your swat object
            this.swat.deleteProduct(lid, epi, 
                (response) => {
                    // console.log(`Successfully deleted product ${epi} from list ${lid}`, response);
                    onSuccess(response);
                },
                (error) => {
                    console.error(`Error deleting product ${epi} from list ${lid}`, error);
                    onError(error);
                }
            );
        }

        // Add new method to handle moving all SFL items to cart
        handleMoveAllToCart = async () => {
            // Check if we have SFL items
            if (!this.sflListContents || this.sflListContents.length === 0) {
                // console.log('No items in Save For Later to move to cart');
                return;
            }
            
            // Update button state
            this.elements.sflMoveAllToCartButton.textContent = SwymcsCustomWishlistPopup.CONFIG.BUTTON_TEXT.ADDING;
            this.elements.sflMoveAllToCartButton.disabled = true;
            
            try {
                // Create an array to track products that fail to add to cart
                const failedProducts = [];
                
                // Process each product in the SFL list
                for (const item of this.sflListContents) {
                    const product = {
                        empi: item.empi,
                        epi: item.epi,
                        du: item.du
                    };
                    
                    try {
                        // Use the unified product action
                        await this.performProductAction('addToCart', product, {
                            productType: SwymcsCustomWishlistPopup.TYPES.SFL
                        });
                    } catch (error) {
                        console.error(`Failed to process product ${item.dt || item.epi}:`, error);
                        failedProducts.push(item);
                    }
                }
                
                // If we have failed products, show error
                if (failedProducts.length > 0) {
                    this.showError(`Failed to add ${failedProducts.length} item(s) to cart`);
                }
                
                // Refresh SFL list
                await this.fetchSfl();
                
                // Show success message if appropriate
                if (failedProducts.length === 0) {
                    // All items were successfully moved to cart
                    this.elements.sflMoveAllToCartButton.textContent = SwymcsCustomWishlistPopup.CONFIG.BUTTON_TEXT.ADDED_TO_CART;
                    setTimeout(() => {
                        this.elements.sflMoveAllToCartButton.textContent = 'Move all to cart';
                        this.elements.sflMoveAllToCartButton.disabled = false;
                    }, 2000);
                } else {
                    // Reset button if there were failures
                    this.elements.sflMoveAllToCartButton.textContent = 'Move all to cart';
                    this.elements.sflMoveAllToCartButton.disabled = false;
                }
            } catch (error) {
                this.handleError(error, 'move all items to cart');
                
                // Reset button state
                this.elements.sflMoveAllToCartButton.textContent = 'Move all to cart';
                this.elements.sflMoveAllToCartButton.disabled = false;
            }
        }

        // Add unified product actions
        async performProductAction(action, product, options = {}) {
            const { productCard, listId, productType } = options;
            switch (action) {
                case 'addToCart':
                    // Get the button and update its text if we have a product card
                    const addToCartBtn = productCard?.querySelector('.swymcs-product-card-btn');
                    const originalText = addToCartBtn?.textContent;
                    
                    if (addToCartBtn) {
                        addToCartBtn.textContent = this.Strings.AddToCartCTAAdding;
                        addToCartBtn.disabled = true;
                    }
                    
                    try {
                        await this.addToCart(product);
                        
                        // Update button to show "Added to cart"
                        if (addToCartBtn) {
                            addToCartBtn.textContent = this.Strings.AddToCartCTAAlreadyAdded;
                            addToCartBtn.classList.add('already-in-cart');
                            addToCartBtn.disabled = false;
                        }
                        
                        // For SFL, remove from list after adding to cart
                        if (productType === SwymcsCustomWishlistPopup.TYPES.SFL) {
                            if (productCard) productCard.remove();
                            await this.deleteFromSfl(product);
                            this.updateSflAfterRemove(product.epi);
                        }
                        
                        return true;
                    } catch (error) {
                        // Restore original button state
                        if (addToCartBtn) {
                            addToCartBtn.textContent = originalText || this.Strings.AddToCartCTACanAdd;
                            addToCartBtn.disabled = false;
                        }
                        this.handleError(error, 'add to cart', this.Strings.AddToCartErrorText);
                        throw error;
                    }
                
                case 'removeFromList':
                    if (productCard) productCard.remove();
                    
                    try {
                        if (productType === SwymcsCustomWishlistPopup.TYPES.WISHLIST) {
                            await this.deleteFromWishlist(listId, product);
                            this.updateWishlistAfterRemove(listId, product.epi);
                        } else if (productType === SwymcsCustomWishlistPopup.TYPES.SFL) {
                            await this.deleteFromSfl(product);
                            this.updateSflAfterRemove(product.epi);
                        }
                        return true;
                    } catch (error) {
                        this.handleError(error, 'remove from list');
                        throw error;
                    }
                
                default:
                    throw new Error(`Unknown product action: ${action}`);
            }
        }

        // Update additional options to include "Add all to cart"
        updateAdditionalOptionsContainer() {
            const additionalOptions = this.elements.additionalOptions;
            if (!additionalOptions) return;
            
            // Clear existing options
            additionalOptions.innerHTML = '';
            
            // Add "Clear List" option
            const clearListOption = document.createElement('div');
            clearListOption.className = 'swymcs-additional-option';
            clearListOption.innerHTML = `
                <button
                    aria-label="Clear List"
                    id="swymcs-clear-list"
                    data-action="clear"
                    class="swymcs-top-control-button swymcs-primary-font"
                >
                    <div class="swymcs-share-buttons-icon">
                        <svg
                            clip-rule="evenodd"
                            height="15"
                            fill-rule="evenodd"
                            stroke-linejoin="round"
                            stroke-miterlimit="2"
                            viewBox="0 0 24 24"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path fill="#434655" d="m6 18v3c0 .621.52 1 1 1h14c.478 0 1-.379 1-1v-14c0-.478-.379-1-1-1h-3v-3c0-.478-.379-1-1-1h-14c-.62 0-1 .519-1 1v14c0 .621.52 1 1 1zm10.5-12h-9.5c-.62 0-1 .519-1 1v9.5h-2.5v-13h13z" fill-rule="nonzero"></path>
                        </svg>
                    </div>
                    <span class="swymcs-share-button-text">Clear List</span>
                </button>
            `;
            additionalOptions.appendChild(clearListOption);
            
            // Add "Add all to cart" option
            const addAllToCartOption = document.createElement('div');
            addAllToCartOption.className = 'swymcs-additional-option';
            addAllToCartOption.innerHTML = `
                <button
                    aria-label="Add All to Cart"
                    id="swymcs-add-all-to-cart"
                    data-action="add-all"
                    class="swymcs-top-control-button swymcs-primary-font"
                >
                    <div class="swymcs-share-buttons-icon">
                        <svg 
                            height="15" 
                            viewBox="0 0 24 24" 
                            fill="none" 
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path d="M8 22C8.55228 22 9 21.5523 9 21C9 20.4477 8.55228 20 8 20C7.44772 20 7 20.4477 7 21C7 21.5523 7.44772 22 8 22Z" stroke="#434655" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M19 22C19.5523 22 20 21.5523 20 21C20 20.4477 19.5523 20 19 20C18.4477 20 18 20.4477 18 21C18 21.5523 18.4477 22 19 22Z" stroke="#434655" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M2.05 2.05H4.05L6.71 14.47C6.80817 14.9248 7.06284 15.3315 7.43142 15.6198C7.8 15.9082 8.26209 16.0603 8.73 16.05H18.55C19.018 16.0603 19.48 15.9082 19.8486 15.6198C20.2172 15.3315 20.4718 14.9248 20.57 14.47L22.05 6.05H5.12" stroke="#434655" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M12 8V12" stroke="#434655" stroke-width="2" stroke-linecap="round"/>
                            <path d="M15 10H9" stroke="#434655" stroke-width="2" stroke-linecap="round"/>
                        </svg>
                    </div>
                    <span class="swymcs-share-button-text">Add All to Cart</span>
                </button>
            `;
            additionalOptions.appendChild(addAllToCartOption);
            
            // Add "Delete List" option
            const deleteListOption = document.createElement('div');
            deleteListOption.className = 'swymcs-additional-option';
            deleteListOption.innerHTML = `
                <button
                    aria-label="Delete List"
                    id="swymcs-delete-list"
                    data-action="delete"
                    class="swymcs-top-control-button swymcs-primary-font"
                >
                    <div class="swymcs-share-buttons-icon">
                        <svg
                            width="15"
                            height="15"
                            viewBox="0 0 18 18"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M4.07616 16.0272C4.07616 16.8973 4.78164 17.6027 5.65166 17.6027H11.6535C12.5235 17.6027 13.2289 16.8973 13.2289 16.0272V5.02747H4.07616V16.0272ZM13.2289 2.15112H10.9672L10.18 1.36484H7.1234L6.33797 2.15112H4.07616V3.93747H13.2289V2.15112Z"
                            fill="#434655"
                            />
                        </svg>
                    </div>
                    <span class="swymcs-share-button-text">Delete List</span>
                </button>
            `;
            additionalOptions.appendChild(deleteListOption);
            
            // Add event listeners
            // const clearListBtn = additionalOptions.querySelector('#swymcs-clear-list');
            const addAllToCartBtn = additionalOptions.querySelector('#swymcs-add-all-to-cart');
            // const deleteListBtn = additionalOptions.querySelector('#swymcs-delete-list');
            
            // clearListBtn?.addEventListener('click', () => {
            //     this.openConfirmationModal('clear');
            // });
            
            addAllToCartBtn?.addEventListener('click', () => {
                this.handleAddAllToCart();
            });
            
            // deleteListBtn?.addEventListener('click', () => {
            //     this.openConfirmationModal('delete');
            // });
        }

        // Implement handleAddAllToCart method for the wishlist
        async handleAddAllToCart() {
            const currentList = this.lists.find(l => l.lid === this.state.currentListId);
            if (!currentList || !currentList.listcontents || currentList.listcontents.length === 0) {
                this.showError('No items in list to add to cart');
                return;
            }
            
            // Show loading indicator in the button
            const addAllBtn = this.querySelector('#swymcs-add-all-to-cart');
            if (addAllBtn) {
                addAllBtn.querySelector('.swymcs-share-button-text').textContent = 'Adding...';
                addAllBtn.disabled = true;
            }
            
            try {
                // Create an array to track products that fail to add to cart
                const failedProducts = [];
                
                // Process each product in the list
                for (const item of currentList.listcontents) {
                    const product = {
                        empi: item.empi,
                        epi: item.epi,
                        du: item.du
                    };
                    
                    try {
                        // Only add to cart, don't remove from wishlist
                        await this.addToCart(product);
                    } catch (error) {
                        console.error(`Failed to add product ${item.dt || item.epi} to cart:`, error);
                        failedProducts.push(item);
                    }
                }
                
                // Close the additional options
                this.elements.additionalOptionsBackground.classList.add('swym-hide-container');
                this.elements.additionalOptionsContainer.classList.add('swym-hide-container');
                
                // If we have failed products, show error
                if (failedProducts.length > 0) {
                    this.showError(`Failed to add ${failedProducts.length} item(s) to cart`);
                } else {
                    // Show success notification
                    let html = '<div class="swymcs-notif-container">' + 
                    this.elements.successIcon + '<span>' + this.Strings.AddAllToCartSuccessText.replace(
                        /{{{?addCount}?}}/g,
                        currentList.listcontents.length) + '</span></div>';
                    this.swat.ui.uiRef.showNotification({message: `${html}`});
                    // this.swat.ui.uiRef.showSuccessNotification({ message: 'All items added to cart!' });
                }
            } catch (error) {
                this.handleError(error, 'add all items to cart');
            } finally {
                // Reset button state
                if (addAllBtn) {
                    addAllBtn.querySelector('.swymcs-share-button-text').textContent = 'Add All to Cart';
                    addAllBtn.disabled = false;
                }
            }
        }

        // Update toggleModal method to use the new modal management
        toggleModal(modalName, show, data = {}) {
            const modalMappings = {
                'confirmation': {
                    container: this.elements.confirmationModal,
                    background: this.elements.additionalOptionsBackground,
                    onShow: () => {
                        const listName = this.getCurrentListName();
                        const text = data.actionType === 'delete' 
                        ?this.Strings.DeleteWishlistPopupConfirmMessage.replace(
                            /{{{?listName}?}}/g, listName ) 
                        :this.Strings.ClearWishlistPopupConfirmMessage.replace(
                            /{{{?listName}?}}/g, listName )
                        this.elements.confirmationText.innerHTML = text;
                        this.currentActionType = data.actionType;
                    },
                    onHide: () => {
                        this.currentActionType = null;
                    }
                },
                'share': {
                    container: this.elements.sharePopup,
                    background: this.elements.sharePopupBg,
                    onShow: () => {
                        if (!this.state.currentListId) {
                            this.showError('No list selected for sharing');
                            return false; // Prevent showing
                        }
                        
                        // Store the current list data for sharing
                        this.shareListData = {
                            lid: this.state.currentListId,
                            lname: this.getCurrentListName()
                        };
                        
                        // Prefill message field with default text
                        const senderInput = this.querySelector('#swymcs-sender-name');
                        const emailInput = this.querySelector('#swymcs-recipient-email');
                        const messageInput = this.querySelector('#swymcs-share-message');
                        
                        if (messageInput) {
                            const listName = this.getCurrentListName();
                            // messageInput.value = `Check out my ${listName} list!`;
                            messageInput.value = this.Strings.ShareWishlistPopupNoteDefault.replace(
                                /{{{?wishlistName}?}}/g, listName);
                        }
                        
                        // Reset other fields
                        if (senderInput) senderInput.value = '';
                        if (emailInput) emailInput.value = '';
                        
                        document.body.classList.add('swym-share-modal-active');
                        return true;
                    },
                    onHide: () => {
                        document.body.classList.remove('swym-share-modal-active');
                    }
                },
                'additionalOptions': {
                    container: this.elements.additionalOptionsContainer,
                    background: this.elements.additionalOptionsBackground,
                    onShow: null,
                    onHide: null
                },
                'createList': {
                    container: this.elements.createNewListPopup,
                    background: this.elements.createNewListBg,
                    onShow: () =>{
                        let newListPopupContent = this.elements.createNewListPopup.querySelector('.swymcs-newlist-popup-content');
                        newListPopupContent.classList.remove('swym-hide-container')
                        newListPopupContent.classList.add('swym-active-modal');
                    },
                    onHide: null
                },
                'renameList': {
                    container: this.elements.renameListPopup,
                    background: this.elements.renameListBg,
                    onShow: () =>{
                        let renameListPopupContent = this.elements.renameListPopup.querySelector('.swymcs-renamelist-popup-content');
                        renameListPopupContent.classList.remove('swym-hide-container')
                        renameListPopupContent.classList.add('swym-active-modal');
                    },
                    onHide: null
                }
            };
            
            const modal = modalMappings[modalName];
            if (!modal) {
                console.error(`Modal ${modalName} not found`);
                return;
            }
            
            // Call onShow handler if provided and showing
            if (show && modal.onShow && modal.onShow() === false) {
                return; // Abort showing if handler returns false
            }
            
            // Toggle visibility classes
            if (show) {
                modal.container.classList.remove('swym-hide-container');
                modal.container.classList.add('swym-active-popup');
                if (modal.background) {
                    modal.background.classList.remove('swym-hide-container');
                }
            } else {
                modal.container.classList.add('swym-hide-container');
                modal.container.classList.remove('swym-active-popup');
                if (modal.background) {
                    modal.background.classList.add('swym-hide-container');
                }
                
                // Call onHide handler if provided
                if (modal.onHide) modal.onHide();
            }
        }

        // Update renderProductCard method to use the new renderProductCard method
        renderProductCard(item, type, listId) {
            const isInCart = this.swat.platform.isInDeviceCart(item.epi);
            const isAvailable = item.productData?.variants.find(variant => variant.id == item.epi)?.available ? true : false;
            
            // Determine button text based on state
            let buttonText;
            if (!isAvailable) {
                buttonText = this.Strings.AddToCartCTACannotAdd;
            } else if (isInCart) {
                buttonText = this.Strings.AddToCartCTAAlreadyAdded;
            } else {
                buttonText = this.Strings.AddToCartCTACanAdd;
            }
            
            return `
                <div class="swymcs-product-card" 
                    productType="${type}" 
                    data-lid="${listId}" 
                    data-empi="${item.empi}" 
                    data-epi="${item.epi}" 
                    data-du="${item.du}"
                    role="article"
                    aria-label="${item.dt || 'Product'}">
                    <button class="swymcs-product-card-remove-btn" aria-label="Remove ${item.dt || 'product'} from ${type}">
                        <svg onclick="event.target.closest('.swymcs-product-card-remove-btn').click()" width="12" height="11" viewBox="0 0 12 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M0.873047 10.3555C0.772786 10.2598 0.704427 10.1413 0.667969 10C0.636068 9.86328 0.638346 9.72884 0.674805 9.59668C0.711263 9.45996 0.777344 9.34375 0.873047 9.24805L4.77637 5.33789L0.873047 1.43457C0.777344 1.33887 0.711263 1.22493 0.674805 1.09277C0.642904 0.956055 0.642904 0.819336 0.674805 0.682617C0.711263 0.545898 0.777344 0.427409 0.873047 0.327148C0.973307 0.222331 1.0918 0.153971 1.22852 0.12207C1.36523 0.0901693 1.49967 0.0924479 1.63184 0.128906C1.76855 0.160807 1.88704 0.224609 1.9873 0.320312L5.89062 4.23047L9.80078 0.320312C9.94661 0.174479 10.1289 0.101562 10.3477 0.101562C10.5664 0.101562 10.7533 0.176758 10.9082 0.327148C11.0632 0.477539 11.1383 0.664388 11.1338 0.887695C11.1338 1.10645 11.0609 1.28874 10.915 1.43457L7.00488 5.33789L10.915 9.24805C11.0609 9.39388 11.1338 9.57617 11.1338 9.79492C11.1338 10.0137 11.0586 10.2005 10.9082 10.3555C10.7533 10.5104 10.5664 10.5856 10.3477 10.5811C10.1289 10.5811 9.94661 10.5081 9.80078 10.3623L5.89062 6.45215L1.9873 10.3623C1.88704 10.458 1.76855 10.5218 1.63184 10.5537C1.49967 10.5902 1.36523 10.5902 1.22852 10.5537C1.0918 10.5218 0.973307 10.4557 0.873047 10.3555Z" fill="white"/>
                        </svg>
                    </button>
                    <div class="swymcs-product-card-image">
                        <img class="swymcs-product-card-image" src="${item.iu}" alt="${item.dt || ''}" loading="lazy">
                    </div>
                    <div class="swymcs-product-card-info swymcs-flex-column-start">
                        <a href="${item.du}" class="swymcs-product-card-name">${item.dt || 'Product'}</a>
                        <span class="swymcs-product-card-price"><strong>${window.Shopify.locale == 'de' ? window.swymFormatMoneyFunction(item.pr*100, window.Shopify.money_format, true) : window.swymFormatMoneyFunction(item.pr*100, window.Shopify.money_format)}</strong></span>
                        <span class="swymcs-product-card-variant-name">${item.vi || ''}</span>
                    </div>
                    <button id="swymcs-sfl-move-to-cart-btn" 
                        class="swymcs-primary-button swymcs-product-card-btn ${isInCart ? 'already-in-cart' : ''}"
                        ${!isAvailable ? 'disabled' : ''}
                        aria-label="${buttonText} ${item.dt || 'product'}">
                        ${buttonText}
                    </button>
                </div>`;
        }

        // Add standardized API call method
        async apiCall(method, ...args) {
            return new Promise((resolve, reject) => {
                if (!this.swat) {
                    reject(new Error(SwymcsCustomWishlistPopup.CONFIG.ERROR_MESSAGES.SWYM_NOT_INITIALIZED));
                    return;
                }
                
                // Extract the method from swat or its subobjects
                const methodPath = method.split('.');
                let apiMethod = this.swat;
                
                for (const segment of methodPath) {
                    apiMethod = apiMethod[segment];
                    if (!apiMethod) {
                        reject(new Error(`Method ${method} not found`));
                        return;
                    }
                }
                
                // Add success and error callbacks to args
                apiMethod(
                    ...args,
                    (response) => {
                        // console.log(`Successfully called ${method}`, response);
                        resolve(response);
                    },
                    (error) => {
                        console.error(`Error calling ${method}`, error);
                        reject(new Error(error?.message || `Failed to call ${method}`));
                    }
                );
            });
        }

        // Add standardized error handling
        handleError(error, context, userMessage = null) {
            const errorMsg = error?.message || 'An unknown error occurred';
            console.error(`Error in ${context}:`, error);
            
            // Show user-friendly error
            this.showError(userMessage || `Failed to ${context}. ${errorMsg}`);
            
            // Return false to indicate error (useful in promise chains)
            return false;
        }

        // Add this function to initialize the confirmation modal close button
        initConfirmationModalCloseButton() {
            // Make sure the closeConfirmationModalBtn closes the modal when clicked
            this.elements.closeConfirmationModalBtn.addEventListener('click', () => {
                this.closeConfirmationModal();
                // should also close the additional options and additional options background
                this.elements.additionalOptionsContainer?.classList.add('swym-hide-container');
                this.elements.additionalOptionsBackground?.classList.add('swym-hide-container');
            });
        }
    }

    customElements.define("swymcs-custom-wishlist-popup", SwymcsCustomWishlistPopup);
}